import { type ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: boolean;
}

interface CardHeaderProps {
  title: string;
  action?: ReactNode;
}

export function Card({ children, className = '', padding = true }: CardProps) {
  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 ${padding ? 'p-5' : ''} ${className}`}>
      {children}
    </div>
  );
}

Card.Header = function CardHeader({ title, action }: CardHeaderProps) {
  return (
    <div className="flex items-center justify-between pb-4 mb-4 border-b border-gray-200">
      <h3 className="text-lg font-medium text-gray-900">{title}</h3>
      {action}
    </div>
  );
};
